import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import { Link } from "react-router-dom";

const resources = [
  {
    href: "/resources/scdf-fire-code-2023-digital-workflows",
    title: "SCDF Fire Code 2023 Digital Workflows",
    desc: "Use interactive decision trees to navigate all 11 chapters of the SCDF Fire Code 2023 with clause-referenced outcomes.",
    icon: "ri-git-branch-line",
    tag: "Compliance Tool",
    image: "https://storage.readdy-site.link/project_files/bad53886-d0ad-4ee3-acb4-5b763a394fe2/7ec9b5c3-3aee-4b42-bca0-cd81a242fd02_compressed_Depositphotos_25184919_l-2015.webp",
  },
  {
    href: "/resources/types-of-fires",
    title: "Types and Classes of Fires",
    desc: "Understand the five main fire classes (A, B, C, D, K) and what extinguisher to use for each.",
    icon: "ri-fire-line",
    tag: "Fire Education",
    image: "https://storage.readdy-site.link/project_files/bad53886-d0ad-4ee3-acb4-5b763a394fe2/80e01107-a3eb-457d-b1a8-ed95e8020cb8_compressed_Depositphotos_211957458_l-2015-min.webp",
  },
  {
    href: "/resources/types-of-fire-extinguishers",
    title: "Types of Fire Extinguishers in Singapore",
    desc: "A guide to ABC dry powder, CO2, wet chemical, foam, water-based and Class D extinguishers — which one fits your needs.",
    icon: "ri-shield-check-line",
    tag: "Fire Equipment",
    image: "https://storage.readdy-site.link/project_files/bad53886-d0ad-4ee3-acb4-5b763a394fe2/f1b898d6-3f85-46f1-8b2c-c8abec46cc38_compressed_Depositphotos_63936807_l-2015-min.webp",
  },
  {
    href: "/resources/active-passive-fire-protection",
    title: "Active vs Passive Fire Protection",
    desc: "Learn the key differences between active fire detection systems and passive structural protection — and why you need both.",
    icon: "ri-layout-grid-line",
    tag: "Fire Protection",
    image: "https://storage.readdy-site.link/project_files/bad53886-d0ad-4ee3-acb4-5b763a394fe2/7760756c-83f6-402c-bc6c-52476ec57411_compressed_Depositphotos_78682994_l-2015-min.webp",
  },
  {
    href: "/resources/water-mist-fire-protection",
    title: "Water Mist Fire Protection",
    desc: "How water mist systems work, their three pressure levels, nozzle types, and unique benefits over conventional sprinklers.",
    icon: "ri-water-flash-line",
    tag: "Suppression Systems",
    image: "https://storage.readdy-site.link/project_files/bad53886-d0ad-4ee3-acb4-5b763a394fe2/2c0e0d60-a8fb-497c-b7b2-7b583ebea612_compressed_Depositphotos_207506126_l-2015.webp",
  },
  {
    href: "/resources/fm200-fire-suppression",
    title: "FM-200 Fire Suppression Gas System",
    desc: "Rapid, waterless, clean gas fire suppression — recommended for data centres, UPS rooms, hospitals and more.",
    icon: "ri-test-tube-line",
    tag: "Gas Suppression",
    image: "https://storage.readdy-site.link/project_files/bad53886-d0ad-4ee3-acb4-5b763a394fe2/84f66381-caa1-4037-a30e-24ebded0c9cd_compressed_Depositphotos_218634112_l-2015.webp",
  },
  {
    href: "/resources/fire-fighting-foam",
    title: "All You Need to Know About Fire Fighting Foam",
    desc: "How foam works, types of foam concentrates (AFFF, AR-AFFF, protein, FFFP), benefits and key applications.",
    icon: "ri-drop-line",
    tag: "Suppression Agents",
    image: "https://storage.readdy-site.link/project_files/bad53886-d0ad-4ee3-acb4-5b763a394fe2/92af08f3-be6b-4f59-afe3-d36b1ad4beb2_compressed_Depositphotos_26333619_l-2015.webp",
  },
  {
    href: "/resources/kitchen-fire-suppression",
    title: "Kitchen Fire Suppression Systems",
    desc: "What restaurant owners need to know — how kitchen suppression systems work, their advantages, and how to choose the right one.",
    icon: "ri-restaurant-2-line",
    tag: "Restaurant Safety",
    image: "https://storage.readdy-site.link/project_files/bad53886-d0ad-4ee3-acb4-5b763a394fe2/60dc16d5-ebff-40d9-b758-ac886b2c67e2_compressed_dreamstime_m_104980760.webp",
  },
  {
    href: "/resources/fire-safety-regulations",
    title: "Fire Safety Regulations Singapore",
    desc: "A comprehensive guide to SCDF regulations, certifications, permits and penalties for non-compliance.",
    icon: "ri-government-line",
    tag: "Compliance",
    image: "https://storage.readdy-site.link/project_files/bad53886-d0ad-4ee3-acb4-5b763a394fe2/cc8ab1aa-4500-41ac-9924-a2ef0502113d_compressed_Depositphotos_25184919_l-2015-min.webp",
  },
  {
    href: "/resources/fsc-application-process",
    title: "Fire Safety Certificate (FSC) Application Process",
    desc: "Step-by-step guide to the FSC application — from engaging a QP and submitting plans to SCDF, to final inspections and certification.",
    icon: "ri-file-list-3-line",
    tag: "Compliance",
    image: "https://storage.readdy-site.link/project_files/bad53886-d0ad-4ee3-acb4-5b763a394fe2/559d8bb8-e38d-4b98-b636-c05644254930_compressed_c7daa0c0-284b-40ce-ac15-97d4c588d74b.webp",
  },
  {
    href: "/resources/safety-at-work",
    title: "Fire Safety at Work",
    desc: "Key elements of workplace fire safety including risk assessments, systems, training and common precautions.",
    icon: "ri-building-2-line",
    tag: "Workplace Safety",
    image: "https://storage.readdy-site.link/project_files/bad53886-d0ad-4ee3-acb4-5b763a394fe2/246a9e4e-8a52-4402-aee2-cc6708e2467c_compressed_dreamstime_m_121976517.webp",
  },
  {
    href: "/resources/fire-safety-tips-workplace",
    title: "Fire Safety Tips for Employees",
    desc: "Six essential fire safety tips every employee should know — from electrical checks to fire warden responsibilities.",
    icon: "ri-user-star-line",
    tag: "Employee Training",
    image: "https://storage.readdy-site.link/project_files/bad53886-d0ad-4ee3-acb4-5b763a394fe2/82e249e9-dcb3-43cb-b23f-468dd970ac31_compressed_dreamstime_m_19769264.webp",
  },
  {
    href: "/resources/office-fire-safety",
    title: "Office Fire Safety",
    desc: "How to protect your office from fire threats — hazard identification, staff training, inspections and keeping exits clear.",
    icon: "ri-building-line",
    tag: "Commercial Safety",
    image: "https://storage.readdy-site.link/project_files/bad53886-d0ad-4ee3-acb4-5b763a394fe2/bf49d70f-151e-4db4-9169-333bc6914693_compressed_Depositphotos_83445092_l-2015-min.webp",
  },
  {
    href: "/resources/electrical-fire-safety",
    title: "Electrical Fire Safety and Prevention Tips",
    desc: "Practical tips to prevent electrical fires — from using industry-standard systems to responsible appliance use.",
    icon: "ri-flashlight-line",
    tag: "Prevention",
    image: "https://storage.readdy-site.link/project_files/bad53886-d0ad-4ee3-acb4-5b763a394fe2/9b789789-40a5-48c3-8a81-70e176488bce_compressed_Depositphotos_10827891_l-2015-min.webp",
  },
  {
    href: "/resources/prevent-industrial-fires",
    title: "How to Prevent Industrial Fires",
    desc: "Key guidelines for industrial fire prevention — training, hazardous material storage, hygiene and fire safety compliance.",
    icon: "ri-building-4-line",
    tag: "Industrial Safety",
    image: "https://storage.readdy-site.link/project_files/bad53886-d0ad-4ee3-acb4-5b763a394fe2/6dc6ac34-3022-4a3f-a6a7-79576ea474df_compressed_Depositphotos_3527571_l-2015-min.webp",
  },
];

const categories = [
  { label: "All", count: resources.length },
  { label: "Suppression Systems", count: 3 },
  { label: "Prevention", count: 4 },
  { label: "Compliance", count: 4 },
  { label: "Training", count: 3 },
];

export default function ResourcesPage() {
  return (
    <div className="min-h-screen bg-background-50">
      <Navbar />
      <main>
        {/* Header */}
        <section className="pt-28 md:pt-32 pb-12 md:pb-16 px-4 md:px-6 lg:px-10 bg-background-100">
          <div className="max-w-7xl mx-auto text-center">
            <span className="inline-block text-xs font-semibold uppercase tracking-wider text-accent-500 border border-accent-200 rounded-full px-3 py-1 mb-4">
              Knowledge Hub
            </span>
            <h1 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-foreground-950 leading-tight mb-4">
              Fire Safety <span className="text-primary-500">Resources</span>
            </h1>
            <p className="text-foreground-600 text-base md:text-lg max-w-2xl mx-auto">
              Guides, regulations and educational content to help you understand fire safety requirements in Singapore — from suppression systems to employee training.
            </p>
            <div className="flex items-center justify-center gap-2 mt-6 flex-wrap">
              {categories.map((cat) => (
                <span
                  key={cat.label}
                  className="inline-flex items-center gap-1.5 text-xs font-medium text-foreground-600 bg-background-50 border border-background-200/70 rounded-full px-3 py-1.5"
                >
                  {cat.label}
                  <span className="text-xs text-foreground-400 font-normal">{cat.count}</span>
                </span>
              ))}
            </div>
          </div>
        </section>

        {/* Resources Grid */}
        <section className="px-4 md:px-6 lg:px-10 py-12 md:py-16 max-w-7xl mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
            {resources.map((res) => (
              <Link
                key={res.href}
                to={res.href}
                className="group bg-background-50 rounded-2xl border border-background-200/70 overflow-hidden hover:border-primary-300 transition-all block"
              >
                <div className="h-48 overflow-hidden">
                  <img
                    src={res.image}
                    alt={res.title}
                    className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                    loading="lazy"
                  />
                </div>
                <div className="p-6">
                  <div className="flex items-center gap-3 mb-3">
                    <div className="w-9 h-9 flex items-center justify-center rounded-full bg-primary-100 flex-shrink-0">
                      <i className={`${res.icon} text-primary-600 text-base`}></i>
                    </div>
                    <span className="text-xs font-semibold text-accent-600 bg-accent-50 border border-accent-200/70 rounded-full px-2.5 py-1">
                      {res.tag}
                    </span>
                  </div>
                  <h2 className="font-heading text-lg font-bold text-foreground-950 mb-2 group-hover:text-primary-600 transition-colors">
                    {res.title}
                  </h2>
                  <p className="text-foreground-600 text-sm leading-relaxed mb-4">{res.desc}</p>
                  <div className="flex items-center gap-1 text-primary-500 text-sm font-semibold">
                    Read more
                    <i className="ri-arrow-right-line text-sm group-hover:translate-x-1 transition-transform"></i>
                  </div>
                </div>
              </Link>
            ))}
          </div>
        </section>

        {/* CTA */}
        <section className="bg-background-100 border-t border-background-200/70 py-12 md:py-16">
          <div className="px-4 md:px-6 lg:px-10 max-w-4xl mx-auto text-center">
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-4">
              Need Professional Fire Safety Advice?
            </h2>
            <p className="text-foreground-600 text-base max-w-xl mx-auto mb-6">
              We shall try our best to assess your needs and provide tailored fire safety solutions.
            </p>
            <Link
              to="/contact"
              className="inline-flex items-center gap-2 px-7 py-3.5 rounded-full bg-primary-500 text-background-50 text-sm font-semibold hover:bg-primary-600 transition-colors whitespace-nowrap"
            >
              Contact Us
              <i className="ri-arrow-right-line"></i>
            </Link>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}
